import { FC } from 'react';

import {
  Tabs as MantineTabs,
  MantineColor,
  TabsPanelProps as MantineTabsPanelProps,
  useMantineColorScheme
} from '@mantine/core';

interface TabsPanelProps extends MantineTabsPanelProps {
  fullHeight?: boolean;
  bg?: MantineColor;
}

const TabsPanel: FC<TabsPanelProps> = ({ fullHeight, bg, children, ...rest }) => {
  const colorScheme = useMantineColorScheme();
  return (
    <MantineTabs.Panel
      {...rest}
      style={(theme) => ({
        background: bg
          ? colorScheme.colorScheme === 'light'
            ? theme.colors[bg][0]
            : theme.colors.dark[5]
          : undefined,
        height: fullHeight ? 'calc(100% - 38px)' : 'auto'
      })}
    >
      {children}
    </MantineTabs.Panel>
  );
};

export { TabsPanel };
export type { TabsPanelProps };
